<template>
  <AppHeaderDropdown right class="pr-2">
    <template slot="header">
      <i class="icon-user pr-1" :title="userDisplay"></i>
      <span class="d-md-down-none">{{userDisplay}}</span>
    </template>
    <template slot="dropdown">
      <b-dropdown-item to="/profile">
        <i class="icon-user"/> Profile
      </b-dropdown-item>
      <b-dropdown-item to="/login">
        <i class="icon-logout"/> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { mapState } from 'vuex';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
  name: 'DropdownAccount',
  components: {
    AppHeaderDropdown
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('user', ['user', 'claims']),
    userDisplay() {
      return (this.claims && this.claims.impersonate) ? 'IMPERSONATING' : this.user;
    }
  }
}
</script>
